// ═══════════════════════════════════════════════════════════════
// useToast — gestion globale des notifications "toast"
// ═══════════════════════════════════════════════════════════════
// Stockage réactif global (Composition API), consommé par
// `components/ui/ToastContainer.vue` monté dans App.vue.
//
// Usage :
//   const toast = useToast();
//   toast.success('auth.signupSuccess');
//   toast.error('errors.ERR_INVALID_CREDENTIALS');
// ═══════════════════════════════════════════════════════════════

import { reactive } from 'vue';

const state = reactive({
  items: [],
});

let nextId = 1;
const DEFAULT_TIMEOUT = 4000;

function push(type, messageKey, options = {}) {
  const id = nextId++;
  const item = {
    id,
    type, // 'success' | 'error' | 'info' | 'warning'
    messageKey, // clé i18n
    params: options.params || {},
    timeout: options.timeout ?? DEFAULT_TIMEOUT,
  };
  state.items.push(item);
  if (item.timeout > 0) {
    setTimeout(() => dismiss(id), item.timeout);
  }
  return id;
}

function dismiss(id) {
  const idx = state.items.findIndex((t) => t.id === id);
  if (idx >= 0) state.items.splice(idx, 1);
}

function clear() {
  state.items.splice(0, state.items.length);
}

export function useToast() {
  return {
    items: state.items,
    success: (key, opts) => push('success', key, opts),
    error: (key, opts) => push('error', key, opts),
    info: (key, opts) => push('info', key, opts),
    warning: (key, opts) => push('warning', key, opts),
    dismiss,
    clear,
  };
}
